<script setup lang="ts">
const siteTitle = 'United Med-Health'
useHead({
  titleTemplate: (input) => {
    if (input && input !== siteTitle) {
      return `${input} | ${siteTitle}`
    }
    return siteTitle
  },
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
